"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _Checkable = _interopRequireDefault(require("../decorators/Checkable"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _decorators = require("../utils/propTypes/decorators");

var _Styles = require("../utils/Styles");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  cursor: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-flex;\n  position: relative;\n  .hubspot-enable-focus-styles & input:focus ~ .private-icon {\n    ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /*\n    The below line-height enables each UIIcon to fill the\n    height of its UIIconToggle container, preventing icons\n    from getting cut off.\n  */\n  line-height: 117%;\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: ", ";\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/*
  If there is a percentage, the background icon will be the unchecked icon
  for the foreground icon to cover
*/
var foregroundIconStyles = (0, _styledComponents.css)(_templateObject(), _sizes.MERCURY_LAYER, function (_ref) {
  var percentFilled = _ref.percentFilled;
  return percentFilled != null ? percentFilled / 100 + "em" : '';
}); // Pass in allowed props to UIIcon

var StyledUIIcon = (0, _styledComponents.default)(function (_ref2) {
  var checked = _ref2.checked,
      className = _ref2.className,
      isForeground = _ref2.isForeground,
      percentFilled = _ref2.percentFilled,
      role = _ref2.role,
      size = _ref2.size;
  var backgroundIconUnchecked = !checked || percentFilled != null;
  return _react.default.createElement(_UIIcon.default, {
    className: className,
    color: !isForeground && backgroundIconUnchecked ? _colors.FLINT : _colors.MARIGOLD,
    name: !isForeground && backgroundIconUnchecked ? 'favoriteHollow' : 'favorite',
    role: role,
    size: size
  });
}).withConfig({
  displayName: "UIIconToggle__StyledUIIcon",
  componentId: "o308tt-0"
})(_templateObject2(), function (_ref3) {
  var isForeground = _ref3.isForeground;
  return isForeground && foregroundIconStyles;
});

var StyledLabel = _styledComponents.default.label.withConfig({
  displayName: "UIIconToggle__StyledLabel",
  componentId: "o308tt-1"
})(_templateObject3(), _Styles.uiFocus);

var StyledUIIconToggle = (0, _styledComponents.default)(function (_ref4) {
  var __disabled = _ref4.disabled,
      rest = (0, _objectWithoutProperties2.default)(_ref4, ["disabled"]);
  return _react.default.createElement(StyledLabel, rest);
}).withConfig({
  displayName: "UIIconToggle__StyledUIIconToggle",
  componentId: "o308tt-2"
})(_templateObject4(), function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'inherit' : 'pointer';
});
var UIIconToggle = (0, _memoWithDisplayName.default)('UIIconToggle', function (props) {
  var active = props.active,
      ariaLabel = props['aria-label'],
      checked = props.checked,
      className = props.className,
      disabled = props.disabled,
      focus = props.focus,
      hover = props.hover,
      IconComponent = props.IconComponent,
      id = props.id,
      index = props.index,
      _onChange = props.onChange,
      percentFilled = props.percentFilled,
      readOnly = props.readOnly,
      size = props.size,
      tabIndex = props.tabIndex,
      rest = (0, _objectWithoutProperties2.default)(props, ["active", "aria-label", "checked", "className", "disabled", "focus", "hover", "IconComponent", "id", "index", "onChange", "percentFilled", "readOnly", "size", "tabIndex"]);
  var hasPercentage = percentFilled != null;
  var sharedProps = {
    active: active,
    checked: checked,
    disabled: disabled,
    focus: focus,
    hover: hover,
    index: index,
    percentFilled: percentFilled,
    readOnly: readOnly,
    size: size
  };
  return _react.default.createElement(StyledUIIconToggle, (0, _extends2.default)({}, rest, {
    className: className,
    disabled: disabled
  }), _react.default.createElement("input", {
    "aria-label": ariaLabel,
    checked: checked,
    className: "sr-only",
    id: id,
    type: "checkbox",
    onChange: function onChange(evt) {
      if (disabled || readOnly) {
        evt.preventDefault();
        return;
      }

      _onChange(evt);
    },
    tabIndex: tabIndex
  }), _react.default.createElement(IconComponent, (0, _extends2.default)({}, sharedProps, {
    isForeground: false
  })), hasPercentage && _react.default.createElement(IconComponent, (0, _extends2.default)({}, sharedProps, {
    isForeground: true,
    role: "presentation"
  })));
});
UIIconToggle.propTypes = {
  'aria-label': _propTypes.default.string.isRequired,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  defaultChecked: _propTypes.default.bool,
  IconComponent: (0, _decorators.hidden)(_propTypes.default.elementType),
  size: _propTypes.default.oneOfType([_tshirtSize.allSizes, _propTypes.default.oneOf(['xxs', 'xxl'])]),
  onChange: _propTypes.default.func,
  percentFilled: _propTypes.default.number,
  readOnly: _propTypes.default.bool
};
UIIconToggle.defaultProps = {
  checked: false,
  IconComponent: StyledUIIcon,
  size: 'xs',
  tabIndex: 0
};

var _default = (0, _Checkable.default)(UIIconToggle);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/input/UIIconToggle.js
// module id = 716
// module chunks = 209 210 211 212